import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useSearch } from './makeNav';

const evalConfig = (config, key, values) => typeof(config[key]) === 'function'
  ? config[key](values)
  : config[key][values[key]];

export default function DocumentTitle({ template, config }) {
  const params = useParams();
  const query = useSearch();
  const values = { ...params, ...query };
  const exp = /\{(.*?)\}/g;
  const title = template.replace(
    exp,
    (_, p0) => config[p0] ? evalConfig(config, p0, values) : '#ERROR'
  );
  useEffect(() => {
    const previousTitle = document.title;

    document.title = title;
    return (() => {
      document.title = previousTitle;
    });
  }, [title]);

  return null;
}
